export default {
      id: "cross-usage",
      viewBox: "0 0 14 14",
      url: __webpack_public_path__ + "sprite.svg#cross-usage",
      toString: function () {
        return this.url;
      }
    }